import { useEffect, useState } from "react";
import { getParsikConfig, getScripts } from "../../../api/api";
import { errorNotify } from "../../../services/toast.notification";
import Table, { ColumnsType } from "antd/lib/table";
import Spinner from "../../../components/_common/Spinner";
import {NewParsinkConfig} from "./NewParsinkConfig";
import { Button, Modal, Row } from "antd";

export interface InputProps {
    labId:number
}

const ParsinkConfig = (labId:InputProps)=>{
    const [isLoading, setIsLoading] = useState(false);
    const [showNewParsinkConfig, setShowNewParsinkConfig] = useState(false);
    const [data, setData] = useState([]);
    const [newConfigPayload,setNewConfigPayload] = useState({labId:labId});
    const [computerNameScriptData,setComputerNameScriptData] = useState("");
    const [mackAdressScriptData,setMackAdressScriptData] = useState("");
    const [isScriptsModalOpen,setIsScriptsModalOpen] = useState(false);
    const columns: ColumnsType<any> = [
       
        { title: 'prk_LabSQLAuthentication_AutoID', dataIndex: 'prk_LabSQLAuthentication_AutoID', key: 'prk_LabSQLAuthentication_AutoID' },
        { title: 'frk_LabID', dataIndex: 'frk_LabID', key: 'frk_LabID' },
        { title: 'frk_ParsiUserID', dataIndex: 'frk_ParsiUserID', key: 'frk_ParsiUserID' },
        { title: 'str_FullName', dataIndex: 'str_FullName', key: 'str_FullName' },
        { title: 'str_InstanceName', dataIndex: 'str_InstanceName', key: 'str_InstanceName' },
        { title: 'str_MacAddress', dataIndex: 'str_MacAddress', key: 'str_MacAddress' },
        { title: 'str_PlainPassword', dataIndex: 'str_PlainPassword', key: 'str_PlainPassword' },
        { title: 'str_EncryptedPassword', dataIndex: 'str_EncryptedPassword', key: 'str_EncryptedPassword' },
        { title: 'str_Date', dataIndex: 'str_Date', key: 'str_Date' },
        { title: 'str_Time', dataIndex: 'str_Time', key: 'str_Time' },
        { title: 'str_PerDate', dataIndex: 'str_PerDate', key: 'str_PerDate' },
    ];

    const _getParsikConfig = () => {
        setIsLoading(true);
        getParsikConfig(Number(newConfigPayload.labId))
            .then((result: any) => {
                setData(result.data.data)
                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })
    }


    useEffect(() => {
        _getParsikConfig();


    }, []);
    
const onAddConfigClick = () =>{
    setShowNewParsinkConfig(true)
}

const _getScripts = () =>{
    setIsLoading(true);
    getScripts()
        .then((result: any) => {
            debugger;
            setComputerNameScriptData(result.data.data.computerName)
            setMackAdressScriptData(result.data.data.mackAdress)
            setIsScriptsModalOpen(true)
            setIsLoading(false);
        })
        .catch((error) => {
            console.log(error);
            errorNotify(error.response.data.errorMessage, undefined, 5000)
        })}

        const handleOk = () => {
            setIsScriptsModalOpen(false);
          };
        
          const handleCancel = () => {
            setIsScriptsModalOpen(false);
          };
        

    return (
        <div className="tab-content-padding grid-mobile">

<Button type="primary" style={{ backgroundColor: "Green" }} onClick={onAddConfigClick} >افزودن کانفیگ جدید</Button>
<Button type="primary" style={{ backgroundColor: "Green" ,float:'left'}} onClick={()=>_getScripts()} >اسکریپت کمکی computerName  </Button>


          {
            isLoading === false && (
              <>
                {
                  data.length > 0 && (
                    <div className="inner-tabs_content">
                      <Table scroll={{ x: "max-content" }}
                        dataSource={data} columns={columns}
                      />
                    </div>
                  )
                }
                {
                  !(data.length > 0) &&
                  (<p className="empty-data">داده ای برای نمایش موجود نیست.</p>)
                }
              </>
            )
          }
          {
            isLoading === true && (
              <Spinner />
            )
          }
        
        
        
        {showNewParsinkConfig && (             
                <NewParsinkConfig
                visible={showNewParsinkConfig}
                onSubmit={() => console.log(true)}
                onCancel={() => {setShowNewParsinkConfig(false)}}
                payLoad = {newConfigPayload}
                setShowDialog ={() => {setShowNewParsinkConfig(false);}}
            />
            )}

            <Modal style={{direction:'rtl'}} title="اسکریپت های کمکی" open={isScriptsModalOpen} onOk={handleOk} onCancel={handleCancel} footer={[]} width={800} >
            <Row style={{direction:'ltr'}}>
                computerName:  
                <p>{computerNameScriptData}</p>
            </Row>
            <Row style={{direction:'ltr'}}>
                MackAdress:  <p>{mackAdressScriptData}</p>
          </Row>
            
            </Modal>

        </div>



    
      )
}
export default ParsinkConfig;